export const fontNames = [
  { text: 'Arial', value: 'arial, sans-serif'},
  { text: 'Courier', value: 'courier, monospace'},
  { text: 'Courier New', value: '"courier new", monospace'},
  { text: 'Georgia', value: 'georgia, serif'},
  { text: 'Helvetica', value: 'helvetica, sans-serif'},
  { text: 'Lucida Console', value: '"lucida console", monospace'},
  { text: 'Sans-serif', value: 'sans-serif'},
  { text: 'Tahoma', value: 'tahoma, sans-serif'},
  { text: 'Times', value: 'times, serif'},
  { text: 'Times New Roman', value: '"times new roman", serif'},
  { text: 'Trebuchet MS', value: '"trebuchet ms", sans-serif'},
  { text: 'Verdana', value: 'verdana, sans-serif'},
];

export const fontSizes = [
  { text: '10', value: '10px'},
  { text: '11', value: '11px'},
  { text: '12', value: '12px'},
  { text: '13', value: '13px'},
  { text: '14', value: '14px'},
  { text: '15', value: '15px'},
  { text: '16', value: '16px'},
  { text: '17', value: '17px'},
  { text: '18', value: '18px'},
  { text: '19', value: '19px'},
  { text: '20', value: '20px'},
  { text: '21', value: '21px'},
  { text: '22', value: '22px'},
  { text: '23', value: '23px'},
  { text: '24', value: '24px'},
  { text: '25', value: '25px'},
  { text: '26', value: '26px'},
  { text: '27', value: '27px'},
  { text: '28', value: '28px'},
  { text: '29', value: '29px'},
  { text: '30', value: '30px'},
  { text: '31', value: '31px'},
  { text: '32', value: '32px'},
];
